// Talks to the AIHOVI backend (see /server). Set REACT_APP_API_URL in your .env
// (or your hosting platform's build env vars) to point at your deployed backend —
// defaults to localhost for local development.
const BASE = process.env.REACT_APP_API_URL || "http://localhost:4000";
const TOKEN_KEY = "aihovi_token";

function getToken() { return localStorage.getItem(TOKEN_KEY); }
function setToken(t) { t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY); }

async function request(path, { method = "GET", body, auth = true } = {}) {
  const headers = { "Content-Type": "application/json" };
  if (auth) {
    const t = getToken();
    if (t) headers.Authorization = `Bearer ${t}`;
  }
  let res;
  try {
    res = await fetch(`${BASE}${path}`, { method, headers, body: body !== undefined ? JSON.stringify(body) : undefined });
  } catch {
    throw new Error("Can't reach the server. Please check your internet connection and try again.");
  }
  let data = {};
  try { data = await res.json(); } catch { /* empty body is fine */ }
  if (!res.ok) throw new Error(data.error || "Something went wrong. Please try again.");
  return data;
}

export const api = { request, getToken, setToken };
